module.exports = {
  serverAddress: process.env.REACT_APP_HOST
};
